module.exports = __webpack_public_path__ + "img/chinesecompany58.b85e73f5.png";